import { APPLICATION_TRUST_STATUS } from 'src/utils/enums/applicationTrustStatus';
import config from 'src/utils/config';

// Spans must add up to WIN32_APPS_COLUMNS; the column each group ends on carries groupEnd.
export const WIN32_APPS_COLUMN_GROUPS = [
  { title: '', span: 1 },
  { title: 'Application Details', span: 2 },
  { title: 'Affected Devices', span: 3 },
  { title: 'Launch Attempts', span: 3 },
  { title: '', span: 1 },
];

// sortKey is a SortWdacByValues name; status has none there, so it is the one unsortable column.
export const WIN32_APPS_COLUMNS = [
  { key: 'status', label: 'Status', groupEnd: true },
  {
    key: 'arpDisplayName',
    label: 'Name',
    sortable: true,
    sortKey: 'arp_display_name',
    tooltip: 'Version is shown underneath the name.',
  },
  {
    key: 'arpPublisher',
    label: 'Publisher',
    sortable: true,
    sortKey: 'arp_publisher',
    groupEnd: true,
  },
  { key: 'devicesLast5Days', label: '5 Days', sortable: true, sortKey: 'devices_last5days' },
  { key: 'devicesLast30Days', label: '30 Days', sortable: true, sortKey: 'devices_last30days' },
  {
    key: 'devicesLast90Days',
    label: '90 Days',
    sortable: true,
    sortKey: 'devices_last90days',
    groupEnd: true,
  },
  {
    key: 'estimatedLaunchAttemptsLast5Days',
    label: '5 Days',
    sortable: true,
    sortKey: 'estimated_launch_attempts_last5days',
  },
  {
    key: 'estimatedLaunchAttemptsLast30Days',
    label: '30 Days',
    sortable: true,
    sortKey: 'estimated_launch_attempts_last30days',
  },
  {
    key: 'estimatedLaunchAttemptsLast90Days',
    label: '90 Days',
    sortable: true,
    sortKey: 'estimated_launch_attempts_last90days',
    groupEnd: true,
  },
  {
    key: 'managedApplicationMatchCount',
    label: 'Managed App Match Count',
    sortable: true,
    sortKey: 'managed_application_match_count',
  },
];

export const WDAC_APP_PREVIOUS_PATH = 'wdacAppPreviousPath';

const WIN32_ORGANIZING_STATUS_NOTE =
  'This status will not affect your current file set imports or how we record telemetry for this application; it helps you organize your apps before ultimately setting them Trusted or Untrusted.';

// Only a Trusted save restarts the counts: the aggregate drops reports from before a trusted app's
// status date. Untrusting is what switches the app's imports off.
const WIN32_STATUS_NOTES = {
  [APPLICATION_TRUST_STATUS.Trusted]:
    'Marking this app Trusted records that trust in AppControl, but you will need to manually deploy the trusted policies to your endpoints. We reset your device and launch attempt counts on save.',
  [APPLICATION_TRUST_STATUS.Untrusted]:
    'Marking this app Untrusted will disable all of the file set imports in this app, and you will need to remove their policies from your endpoints.',
  [APPLICATION_TRUST_STATUS.InProgress]: WIN32_ORGANIZING_STATUS_NOTE,
  [APPLICATION_TRUST_STATUS.Unknown]: WIN32_ORGANIZING_STATUS_NOTE,
};

// Worded for the status picked in the form, which is not yet the one saved. Nothing picked yet, as
// in a bulk edit, shows no alert.
export const getWin32StatusNote = status => WIN32_STATUS_NOTES[status] ?? null;

export const EDIT_STATUS_NOTE_INFO_LINK = `${config.knowledgeBaseUrl}faq/wdac-results/#why-do-some-win32-apps-show-up-again-after-i-marked-them-trusted`;
